<template lang="pug">
v-data-table.elevation-1(:headers='headers' :items='productos' sort-by='calories' style='margin-top:20px')
      template(v-slot:top)
        v-toolbar(flat dense color='primary' dark)
          v-toolbar-title.justify-center(color='success') Productos Cargados
          v-divider.mx-4(inset vertical)
          v-spacer
          v-dialog(v-model='dialog' scrollable persistent max-width='60%')
            template(v-slot:activator='{ on }')
              v-btn.mx-2(v-show='!agregar' color='success' dark v-on='on') Agregar
            v-card
              v-card-title
                span.headline {{ formTitle }}
              v-divider
              v-card-text
                v-container
                  v-row
                    v-row
                      v-col(cols='6' sm='6' md='6')
                        v-autocomplete(dense outlined :menu-props="{closeOnContentClick: true}"  autocomplete="off" :placeholder="editedItem.idProducto.descripcion" v-model='editedItem.idProducto' :items='productosSelec' label='Producto')
                          template(v-slot:prepend-item)
                              v-divider.mb-2
                              v-list-item( @click='emp = true')
                                v-list-item-avatar(color='grey_1')
                                  v-btn.mx-2(fab dark x-small color='success')
                                    v-icon(dark) mdi-plus
                                v-list-item-content
                                  v-list-item-title
                                    | Agregar producto
                      ProductoM(:dialog='emp' :editedIndex='-1' @close='emp = false' )
                      v-col(cols='6' sm='6' md='6')
                        v-text-field(dense outlined type='number' v-model='editedItem.cantidadPedido' label='Cantidad del Pedido')
              v-card-actions
                v-spacer
                v-btn(color='error' small dark @click.native='close')
                  v-icon mdi-close
                  | Cancelar
                v-btn(color='success' small dark @click.native='save')
                  v-icon mdi-content-save
                  | Guardar
      template(v-if='!readHijo'  v-slot:item.action='{ item }')
        v-icon.mr-2(color='warning' @click='editItem(item)') mdi-pencil
        v-icon(color='error' @click='deleteItem(item)') mdi-delete
      template(v-slot:no-data)
        h1 No existen Productos asociados
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Api from '@/services/methods'
import ProductoM from '../components/modals/ProductoM'
export default {
  props: ['productos', 'productosSelec', 'readHijo', 'agregar'],
  data: () => ({
    dialog: false,
    mostrar: false,
    emp: false,
    headers: [
      { text: 'Codigo', value: 'idProducto.nombre' },
      { text: 'Producto', value: 'idProducto.descripcion' },
      { text: 'Cantidad Pedido', value: 'cantidadPedido' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
      idProducto: '',
      unidadMedidad: '',
      cantidadPedido: 0
    },
    defaultItem: {
      idProducto: '',
      unidadMedidad: '',
      cantidadPedido: 0
    }
  }),

  components: {
    ProductoM
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Cargar Producto' : 'Editar Producto'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    productosSelec (val) {
      val.length > 0 ? (this.mostrar = true) : (this.mostrar = false)
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {},
    editItem (item) {
      this.editedIndex = this.productos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.productos.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres borrar?',
        text: 'No podras revertir esto',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.productos.splice(index, 1)
          this.productosSelec.push({
            value: item.idProducto._id,
            text: item.idProducto.descripcion
          })
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    validarCampos () {
      if (
        this.editedItem.idProducto === '' ||
        this.editedItem.cantidadPedido <= 0
      ) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text:
            'Por favor llene todos los campos para continuar (La cantidad del Pedido debe ser mayor a 0)'
        })
        return true
      }
      return false
    },

    save () {
      if (!this.validarCampos()) {
        if (this.editedIndex > -1) {
          Object.assign(this.productos[this.editedIndex], this.editedItem)
        } else {
          const producto = this.productosSelec.find(
            producto => producto.value === this.editedItem.idProducto
          )
          const descripcion = producto.text
          const nombre = producto.cod
          const _id = producto.value
          this.editedItem.idProducto = { nombre, descripcion, _id }
          this.productos.push(this.editedItem)
          this.$emit('input', (this.value = this.value))
          this.productosSelec.splice(this.productosSelec.indexOf(producto), 1)
        }
        this.close()
      }
    }
  }
}
</script>
